import React from "react";
import { useSelector } from 'react-redux'
import styled from "styled-components";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import { getCurrentUser } from '../store/selectors'

export default () => {
    const user = useSelector(getCurrentUser)
    return (
        <StyledAppBar position="static">
            <StyledToolbar>
                <Typography variant="h6" color="inherit">Medien-Projektdatenbank</Typography>
                <Typography variant="body2">{user.firstName} {user.lastName}</Typography>
            </StyledToolbar>
        </StyledAppBar>
    );
};

const StyledAppBar = styled(AppBar)`
    display: flex;
    flex: 0 0 auto;
`

const StyledToolbar = styled(Toolbar)`
    color: white;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;



// WEBPACK FOOTER //
// ./src/layout/Header.js